/* Single source of truth for the client build number. Shown small on the
   welcome screen and stamped on every completed-session payload. */
export const CLIENT_VERSION = '2.2.0';
